import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import GeckoLocation from '../services/gecko-location';
import { showChatHeads } from '../actions/ui';

class NavLink extends Component {
  onClick() {
    this.props.showChatHeads();
    GeckoLocation.goTo(this.props.to);
  }

  render() {
    const isActive = this.props.exact
      ? this.props.currentPage === this.props.to
      : this.props.currentPage.indexOf(this.props.to) !== -1;
    return (
      <span
        className={`${this.props.className} ${
          isActive ? this.props.activeClassName : ''
        }`}
        onClick={this.onClick.bind(this)}
      >
        {this.props.children}
      </span>
    );
  }
}

NavLink.defaultProps = {
  children: null,
  className: '',
};

NavLink.propTypes = {
  to: PropTypes.string.isRequired,
  exact: PropTypes.bool,
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  children: PropTypes.node,
};

const mapStateToProps = (state) => {
  return {
    currentPage: state.location.page || '',
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showChatHeads: () => {
      dispatch(showChatHeads());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NavLink);
